import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { FileText, Upload, Sparkles, Download } from 'lucide-react';
export function HowItWorks() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      title: 'What CV Go App does (simple)',
      inputTitle: 'You provide:',
      inputItems: ['The Job Description (paste text, upload a PDF, or paste a link)', 'Your Resume (paste text or upload a PDF — OCR supported)'],
      outputTitle: 'CV Go App generates:',
      outputItems: ['A tailored ATS-ready Resume (editable text + professional ATS-friendly PDF)', 'A tailored Formal 1-page Cover Letter matched to the job (editable text + PDF)', 'An in-app Improvement Report showing what changed and why', 'A Missing Keywords section so you can see what the posting expects'],
      finalStep: 'Then you download your documents and apply.'
    },
    es: {
      title: 'Qué hace CV Go App (en simple)',
      inputTitle: 'Tú ingresas:',
      inputItems: ['La oferta de empleo (pegas texto, subes un PDF o pegas un link)', 'Tu CV (pegas texto o subes un PDF — con OCR)'],
      outputTitle: 'CV Go App genera:',
      outputItems: ['Un CV ATS-ready adaptado al puesto (texto editable + PDF profesional ATS-friendly)', 'Una cover letter formal de 1 página alineada a la oferta (texto editable + PDF)', 'Un reporte de mejoras dentro de la app (qué cambió y por qué)', 'Una sección de Missing Keywords (palabras clave faltantes) para ver qué espera la oferta'],
      finalStep: 'Luego descargas los documentos y postulas.'
    }
  };
  const t = content[language];
  return <section className="py-20 bg-gray-50" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="text-center mb-16" data-id="element-57">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-58">{t.title}</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start max-w-5xl mx-auto" data-id="element-59">
          {/* Input Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 h-full" data-id="element-60">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6 text-blue-600" data-id="element-61">
              <Upload className="w-6 h-6" data-id="element-62" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-63">
              {t.inputTitle}
            </h3>
            <ul className="space-y-4" data-id="element-64">
              {t.inputItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-65">
                  <div className="mt-1 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-66" />
                  <span className="text-gray-600" data-id="element-67">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Output Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-blue-600 p-8 rounded-2xl shadow-lg text-white h-full transform md:scale-105" data-id="element-68">
            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-6 text-white" data-id="element-69">
              <Sparkles className="w-6 h-6" data-id="element-70" />
            </div>
            <h3 className="text-xl font-bold text-white mb-6" data-id="element-71">
              {t.outputTitle}
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-72">
              {t.outputItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-73">
                  <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-blue-200 flex-shrink-0" data-id="element-74" />
                  <span className="text-blue-50" data-id="element-75">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center mt-12" data-id="element-76">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-white rounded-full shadow-sm border border-gray-200 text-gray-700 font-medium" data-id="element-77">
            <Download className="w-5 h-5 text-blue-600" data-id="element-78" />
            {t.finalStep}
          </div>
        </motion.div>
      </div>
    </section>;
}